import { t, type MessageKey } from '@ctcells/i18n'

import { cx } from '../../atoms/cx.ts'

import { PROCESS_STEPS } from './processSteps.ts'
import type { MonitoringDeviceKey } from './monitoringModel.ts'

/**
 * 장비 판 아래 **공정 진행 줄** — 그 장비의 상태 순서를 한 줄로 늘어놓고 서버가 준 «지금» 칸 하나만 켠다(`processSteps.ts`).
 *
 * 🔴 색만으로 가르지 않는다 — 지금 칸은 ● 글리프 + 굵은 글자 + `aria-current="step"`, 나머지는 ○.
 * 🔴 지금 칸이 없으면(줄에 없는 상태 · 끊김) 아무 칸도 켜지 않는다. 짐작해 직전 칸을 남기지 않는다.
 */
export function ProcessSteps({
  device,
  name,
  current,
}: {
  device: MonitoringDeviceKey
  name: string
  current: string | undefined
}) {
  const steps = PROCESS_STEPS[device]
  if (steps === undefined) return null
  return (
    <ol aria-label={t('monitoring.eqsheet.process', { name })} className="eqsheet__proc">
      {steps.map((state) => {
        const now = state === current
        return (
          <li
            aria-current={now ? 'step' : undefined}
            className={cx('eqsheet__procstep', now && 'eqsheet__procstep--now')}
            data-state={state}
            key={state}
          >
            <span aria-hidden="true" className="eqsheet__procglyph">
              {now ? '●' : '○'}
            </span>
            {t(`enum.moduleState.${state}` as MessageKey)}
          </li>
        )
      })}
    </ol>
  )
}
